var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.504883 25.1589C0.507792 37.5331 9.45089 48.0692 21.5974 50.0085V32.4284H15.2549V25.1589H21.6049V19.6251C21.321 17.0029 22.2112 14.3895 24.034 12.4938C25.8568 10.598 28.4233 9.61637 31.0374 9.81505C32.9137 9.84554 34.7854 10.0137 36.6374 10.3181V16.5035H33.4774C32.3895 16.3601 31.2958 16.7216 30.5043 17.4862C29.7128 18.2507 29.3093 19.3355 29.4074 20.435V25.1589H36.3349L35.2274 32.4309H29.4074V50.0085C42.5436 47.9197 51.7551 35.8488 50.3687 22.5406C48.9822 9.23241 37.4831 -0.654182 24.2019 0.0432083C10.9208 0.740599 0.506994 11.7778 0.504883 25.1589Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.54b9ded7849a8744f35911f84a5f512e.svg";
export { ForwardRef as ReactComponent };